import { exactMatchNodeNames, contentHighlightedCircles, showContentNodesActive, setShowContentNodesActive } from './state.js';

export function highlightContentNodes(show: boolean): void {
    setShowContentNodesActive(show);

    contentHighlightedCircles.forEach(item => {
        item.circle.classList.remove('circle-highlighted-content');
        if (item.originalFill) {
            item.circle.style.fill = item.originalFill;
        } else {
            item.circle.style.fill = '';
        }
    });
    contentHighlightedCircles.length = 0;

    if (!show) return;

    const chartElement = document.getElementById('chart');
    const circles = chartElement.querySelectorAll('circle');

    circles.forEach(circle => {
        const circleData = circle.__data__;
        if (!circleData || !circleData.data) return;

        const node = circleData.data;
        const hasContent =
            (node.purpose && node.purpose.trim()) ||
            (node.accountabilities && node.accountabilities.length > 0) ||
            (node.responsibilities && node.responsibilities.length > 0);

        if (hasContent) {
            if (!exactMatchNodeNames.has(node.name)) {
                const originalFill = circle.style.fill || circle.getAttribute('fill');
                circle.classList.add('circle-highlighted-content');

                contentHighlightedCircles.push({
                    circle: circle,
                    originalFill: originalFill
                });
            }
        }
    });
}

export function setupContentFilter(): void {
    // Content filter is now a toggle button in the legend popup
    // Setup is handled in legend.ts
}
